import { inject, Injectable } from '@angular/core';
import { DialogService } from '@services/dialog.service';
import { Observable } from 'rxjs';
import { MediaPickerDialogComponent } from '../components/media-picker-dialog/media-picker-dialog.component';
import { MediaPickerDialogInputs } from '../models/media-picker-dialog-inputs';
import { MediaPickerSelection } from '../models/media-picker-selection';

export type OpenMediaPickerOptions = {
  label?: string;
  size?: 's' | 'm' | 'l';
};

@Injectable({ providedIn: 'root' })
export class MediaPickerDialogService {
  private readonly dialogService = inject(DialogService);

  open(inputs: MediaPickerDialogInputs, opts: OpenMediaPickerOptions = {}): Observable<MediaPickerSelection | null> {
    return this.dialogService.openComponent<MediaPickerDialogComponent, MediaPickerSelection | null>(
      MediaPickerDialogComponent,
      { data: inputs, size: opts.size ?? 'l', label: opts.label },
    );
  }
}
